import "../PeopleAccelerator/PeopleAccelerator.css"
import PeopleAcceleratorBanner from "../PeopleAccelerator/PeopleAcceleratorBanner";
import PeopleAcceleratorProgram from './PeopleAcceleratorProgram';
import SeoGeneral from '../BusinessPage/SeoGeneral';

const Index = () => {
    const seoMetaData = {
        title: "Neoo Search Business Accelerator Program | Scale Faster",
        description: "Join the Neoo Search Business Accelerator Program to scale your business faster with expert mentorship, powerful networking, and proven growth strategies.",
        ogImage: "https://neoosearch.com/static/media/Admin_chat%20logo.7fa36f039461d205a125.png",
        ogImageAlt: "NeooSearch People Accelerator Program",
        url: process.env.REACT_APP_APPLICATION_URL + "/business-accelerator-program",
        keywords: "business accelerator program, startup accelerator program, business growth program, startup growth strategy, business mentorship program, scale business faster, business development training, business networking program, SME growth accelerator",
        type: "website",
        site_name: "NeooSearch",
        canonical: process.env.REACT_APP_APPLICATION_URL + "/business-accelerator-program"
    };

    return (
        <>
            <SeoGeneral data={seoMetaData} />
            <div className='PeopleAccelerator_Program'>
                <PeopleAcceleratorBanner />
                <PeopleAcceleratorProgram />

            </div>
        </>
    )
}

export default Index